import React, { Fragment } from "react";
import { Base64 } from "js-base64";
import { getCookie } from "../../modules/utils/cookie";
import { _O } from "../../modules/utils";
import { getToday } from "./ResrvList";

export default (props) => {
  const { hsptInfo, resrvLayer, dupReceipt, goReceipt, setDoctorList } = props;
  const nHour = getToday("FULL").substring(8, 10);
  const nMin = getToday("FULL").substring(10, 12);
  return (
    <Fragment>
      {(hsptInfo.hospital[0].receiptUseType.toString() === "1" ||
        hsptInfo.hospital[0].receiptUseType.toString() === "9") &&
        (hsptInfo.hospital[0].appSTime <= nHour + nMin &&
        hsptInfo.hospital[0].appETime >= nHour + nMin ? (
          <BtnVisitReceipt
            hsptInfo={hsptInfo}
            resrvLayer={resrvLayer}
            dupReceipt={dupReceipt}
            setDoctorList={setDoctorList}
          />
        ) : (
          <NoTimeReceipt
            width={hsptInfo.hospital[0].receiptUseType.toString() === "1" ? "100%" : "50%"}
            hsptInfo={hsptInfo}
          />
        ))}

      {(hsptInfo.hospital[0].receiptUseType.toString() === "2" ||
        hsptInfo.hospital[0].receiptUseType.toString() === "9") &&
        // hsptInfo.hospital[0].callSTime <= nHour + nMin &&
        (hsptInfo.hospital[0].callETime >= nHour + nMin ? (
          <BtnNftfReceipt hsptInfo={hsptInfo} goReceipt={goReceipt} dupReceipt={dupReceipt} />
        ) : (
          <NoTimeReceipt
            width={hsptInfo.hospital[0].receiptUseType.toString() === "2" ? "100%" : "50%"}
            hsptInfo={hsptInfo}
          />
        ))}

      {hsptInfo.hospital[0].receiptUseType.toString() === "0" && (
        <NoTimeReceipt width={"100%"} hsptInfo={hsptInfo} />
      )}
    </Fragment>
  );
};

const BtnVisitReceipt = props => {
  const { hsptInfo, resrvLayer, dupReceipt, setDoctorList } = props;
  return (
    <Fragment>
      <a
        onClick={() => {
          // if (hsptInfo.aplnBtnYn === "Y") {
          resrvLayer(
            "0",
            hsptInfo.hospital[0].hpName,
            hsptInfo.hospital[0].hpKey,
            setDoctorList,
            hsptInfo.hospital[0].appDr
          );
          // } else {
          //   dupReceipt();
          // }
        }}
        className="hf btn-open-visit-receipt"
        style={
          hsptInfo.hospital[0].receiptUseType.toString() == "1"
            ? { width: "100%" }
            : { width: "50%" }
        }>
        방문진료
      </a>
    </Fragment>
  );
};

const BtnNftfReceipt = props => {
  const { hsptInfo, goReceipt, dupReceipt } = props;

  return (
    <a
      onClick={() => {
        console.log("??????????");
        // if (hsptInfo.aplnBtnYn === "Y") {
        if (getCookie("resrvCheckAlert")) {
          console.log("test2222222");
          _O.Open(
            "/nftf/index/" + Base64.encode(JSON.stringify(hsptInfo.hospital[0]))
          );
        } else {
          console.log("test1111111");
          goReceipt(hsptInfo.hospital[0]);
        }
        // } else {
        //   dupReceipt();
        // }
      }}
      className="hf pp"
      style={
        hsptInfo.hospital[0].receiptUseType.toString() == "2"
          ? { width: "100%", color: "#474477", fontWeight: "500" }
          : { width: "50%", color: "#474477", fontWeight: "500" }
      }>
      비대면진료
    </a>
  );
};

const NoTimeReceipt = (props) => {
  return (
    <p
      style={{
        width: props.width,
        borderLeft:
          props.hsptInfo.hospital[0].receiptUseType.toString() == "9" ? "1px solid #eee" : "0px",
      }}
    >
      {props.hsptInfo.hospital[0].receiptUseType.toString() == "9"
        ? "접수마감"
        : "접수 가능한 시간이 아닙니다."}
    </p>
  );
};
